export default "__VITE_PUBLIC_ASSET__22c687ce__"